import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { Helpers } from '~src/ts/helpers/Helpers';
import { IDataConnectionAuthInfo } from '~src/ts/ServerApi/types/IDataConnectionAuthInfo';
import { ConnectionAuthenticationQueryParams, IAuthenticateDatabaseParams } from '../components/AuthenticateConnection';

export namespace AuthenticateDatabase {
    export const opener: any = window.opener;
    export function authenticate(path: string, data: IAuthenticateDatabaseParams): Promise<AxiosResponse<{}>> {
        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            url: path,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: Helpers.serialize(data)
        };
        return axios.request(requestConfig);
    }

    export function getAuthenticateDatabaseParams(
        queryParams: ConnectionAuthenticationQueryParams,
        authInfo: IDataConnectionAuthInfo,
        authenticationRememberPassword: boolean,
        selectedConnectionAuthMode: string,
        authenticationUsername: string,
        authenticationPassword: string
    ): IAuthenticateDatabaseParams {
        const reuse_forever = authenticationRememberPassword && authInfo.rememberPasswordsForever;
        const reuse = authenticationRememberPassword && !authInfo.rememberPasswordsForever;
        const authParams: IAuthenticateDatabaseParams = {
            authentication: selectedConnectionAuthMode,
            username: authenticationUsername,
            crypted: rsa.encrypt(authenticationPassword, { n: authInfo.modulus, e: authInfo.exponent }),
            connection: authInfo.connection,
            path: queryParams.path,
            oauthrequest: false, // BUGZID: 408070 Set oauthrequest to false for all non-OAuth scenarios
            reuse_forever,
            reuse,
        };
        return authParams;
    }

    export function signalAuthCompleted(): void {
        window.parent.postMessage('tableau.authCompleted', '*');
    }

    export function navigateTo(path: string): void {
        WindowLocationService.navigateTo(path);
    }

}
